import { useEffect, useState } from 'react';
import { SyncStatusEvent } from '../store/createPatchRequestsBatcher';
import { useDocumentStore } from './useDocumentStore';

/**
 * Returns whether all edits have been persisted to the backend (sync "settled").
 *
 * `false` while a patch is queued/flushing or has failed to save — used to keep submit/transition
 * actions (Publish, Send for publication, …) disabled until the optimistic local changes are
 * actually saved, so a failed save can't leave a submit button enabled with unsaved data.
 */
export default function useIsSyncSettled(): boolean {
  const { addDataSyncStatusListener } = useDocumentStore();
  const [isSettled, setIsSettled] = useState(true);

  useEffect(() => {
    const handleStatusChange = (event: SyncStatusEvent) => {
      switch (event.type) {
        case 'queued':
        case 'flushing':
        case 'error':
          setIsSettled(false);
          break;
        case 'idle':
          setIsSettled(true);
          break;
      }
    };

    const removeListener = addDataSyncStatusListener(handleStatusChange);
    return removeListener;
  }, [addDataSyncStatusListener]);

  return isSettled;
}
